module.exports = __webpack_public_path__ + "img/binary.8a41a612.png";